var map = {
	"./932.png": "MaWS",
	"./abc.png": "ByXC",
	"./bj.png": "71qQ",
	"./bjrcb.png": "Cq78",
	"./boc.png": "A3bY",
	"./bocom.png": "AfmB",
	"./botj.png": "+ncp",
	"./bsb.png": "JXp+",
	"./cbhb.png": "hVhv",
	"./ccb.png": "RfhG",
	"./ceb.png": "eI9g",
	"./change.png": "Lk8U",
	"./cmb.png": "xm04",
	"./cmbc.png": "fGke",
	"./cqcb.png": "r1vT",
	"./czbank.png": "lnJI",
	"./dalian.png": "udyG",
	"./defaultBank.png": "c7MQ",
	"./dongguan.png": "enxN",
	"./ecitic.png": "1iqm",
	"./gansu.png": "fH6M",
	"./guangfa.png": "clOG",
	"./guizhou.png": "HXor",
	"./gyb.png": "QLQj",
	"./gzcb.png": "N/DK",
	"./gzrc.png": "+Nrw",
	"./hebei.png": "sORZ",
	"./hkb.png": "+seC",
	"./hrbb.png": "hnGh",
	"./hxb.png": "q+88",
	"./hzbank.png": "TZta",
	"./icbc.png": "mg+6",
	"./jie.png": "JzdW",
	"./jinzhou.png": "Tk8x",
	"./jsb.png": "Cbfs",
	"./jx.png": "fo3y",
	"./laishang.png": "RZfz",
	"./lsb.png": "h2jb",
	"./lzbank.png": "BPff",
	"./money.png": "ocK3",
	"./nbcb.png": "t/Ve",
	"./ningxia.png": "a3H0",
	"./njcb.png": "/5rO",
	"./pingan.png": "st+n",
	"./qdcc.png": "w6XW",
	"./qinghai.png": "WcB1",
	"./qlbank.png": "C/7f",
	"./qsb.png": "H5yx",
	"./qzcc.png": "2moS",
	"./rizhao.png": "1qBM",
	"./shb.png": "RR3m",
	"./shengjing.png": "hWGD",
	"./shrcb.png": "fBmO",
	"./spdb.png": "0fK3",
	"./super.png": "b39j",
	"./sxbank.png": "P0ni",
	"./uccb.png": "gYRW",
	"./weifang.png": "2UHA",
	"./whccb.png": "6fwX",
	"./wuxrc.png": "3+B6",
	"./wzcb.png": "soRX",
	"./xy.png": "SF7y",
	"./youchu.png": "dOAR",
	"./zbank.png": "tYxo",
	"./zhhhuarun.png": "Mhjm",
	"./zhjmintcb.png": "MEpD",
	"./zjnshbank.png": "e7o8"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PxJh";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank ^\.\/.*\.png$
// module id = PxJh
// module chunks = 93